import { SlideButtonProps } from '../../../types';
import { PresentationNavigationButton } from '../../atoms/PresentationNavigationButton';
import { PreviousSlideIcon } from '../../atoms/PreviousSlideIcon';
import { useTranslation } from 'react-i18next';

export const PrevSlideButton = (props: SlideButtonProps) => {
    const { t } = useTranslation();
    const { onClick, disabled, classNames } = props;
    return (
        <PresentationNavigationButton type="button" onClick={onClick} className={`${classNames}`} testId="PreviousButton" disabled={disabled}>
            <span className="sr-only">{t('Slide.Button.Previous')}</span>
            <PreviousSlideIcon />
        </PresentationNavigationButton>
    );
};
